import {
  Building2,
  FileSpreadsheet,
  FileText,
  ListChecks,
  Gauge,
  KeyRound,
  RadioTower,
  ShieldCheck,
  UploadCloud,
  Users,
} from 'lucide-react';

import { podeEmAlguma, podeNaPlataforma } from '@/lib/auth/permissoes';
import { type GrupoNavegacao } from '@/ui/shell/tipos';
import { type UsuarioAtual } from '@fiscoai/contracts';

type Item = GrupoNavegacao['itens'][number];
const se = (condicao: boolean, item: Item): Item[] => (condicao ? [item] : []);

function itensDeTrabalho(usuario: UsuarioAtual, pendenciasAltas: number | undefined): Item[] {
  const le = podeEmAlguma(usuario, 'documentos.ler');
  const chaves = podeEmAlguma(usuario, 'chaves.gerenciar');
  const importa = podeEmAlguma(usuario, 'documentos.importar') || chaves;
  return [
    { rotulo: 'Início', para: '/', icone: <Gauge /> },
    ...se(le, { rotulo: 'Documentos', para: '/documentos', icone: <FileText /> }),
    ...se(le, {
      rotulo: 'Pendências',
      para: '/pendencias',
      icone: <ListChecks />,
      ...(pendenciasAltas ? { contador: pendenciasAltas } : {}),
    }),
    ...se(importa, { rotulo: 'Importar notas', para: '/importacao', icone: <UploadCloud /> }),
    ...se(le, { rotulo: 'Captura SEFAZ', para: '/captura', icone: <RadioTower /> }),
    ...se(chaves, { rotulo: 'Aguardando XML', para: '/chaves', icone: <KeyRound /> }),
    ...se(podeEmAlguma(usuario, 'relatorios.ler'), {
      rotulo: 'Relatórios',
      para: '/relatorios',
      icone: <FileSpreadsheet />,
    }),
  ];
}

/** Menu conforme o que a pessoa pode fazer — item sem permissão nem aparece. */
export function navegacaoPara(
  usuario: UsuarioAtual,
  contadores: { pendenciasAltas?: number } = {},
): GrupoNavegacao[] {
  const trabalho = itensDeTrabalho(usuario, contadores.pendenciasAltas);
  const cadastros = [{ rotulo: 'Empresas', para: '/empresas', icone: <Building2 /> }];
  const admin = [
    ...se(podeNaPlataforma(usuario, 'plataforma.usuarios.ler'), {
      rotulo: 'Pessoas',
      para: '/admin/pessoas',
      icone: <Users />,
    }),
    ...se(podeNaPlataforma(usuario, 'plataforma.perfis.gerenciar'), {
      rotulo: 'Perfis',
      para: '/admin/perfis',
      icone: <ShieldCheck />,
    }),
  ];
  return [
    { titulo: 'Trabalho', itens: trabalho },
    { titulo: 'Cadastros', itens: cadastros },
    ...(admin.length > 0 ? [{ titulo: 'Administração', itens: admin }] : []),
  ];
}
